<template lang="pug">
  .menu(v-if="menu")
    .menu__border.menu__border--top
    .menu__border.menu__border--right
    .menu__border.menu__border--bottom
    .menu__border.menu__border--left
    .menu__corner.menu__corner--tl
    .menu__corner.menu__corner--tr
    .menu__corner.menu__corner--bl
    .menu__corner.menu__corner--br
    .menu__left
      .menu__left-btn-open
        .menu__left-btn-open-top
          .menu__left-btn-open-top-wr
            span Меню
            SvgIcon(name="arrow-down" width="12" height="6" class="menu__left-btn-open-ico")
        .menu__left-btn-open-bottom
          .menu__left-btn-open-top-wr
            span Закрыть
            SvgIcon(name="arrow-down" width="12" height="6" class="menu__left-btn-open-ico")
      .menu__left-nav(v-if="menuItems && menuItems.leftNav")
        router-link.menu__left-nav-item(v-for="item in menuItems.leftNav", :to="item.link", :key="item.id", v-on:click.native="closeMenuLocal()")
          .menu__left-nav-item-title {{item.title}}
          SvgIcon.menu__left-nav-item-ico(name="arrow-down", width="10", height="6")
      form.menu__left-filters(v-if="menuItems && menuItems.filters", @submit.prevent="submitFilters(false)")
        .menu__left-filters-item(v-for="filter in menuItems.filters.items", :key="filter.id", :class="(filter.open) ? 'menu__left-filters-item--open' : ''")
          .menu__left-filters-item-top(@click="filterToggle($event)")
            .menu__left-filters-item-title(v-if="filter.title", v-html="filter.title")
            SvgIcon.menu__left-filters-item-arrow(name="arrow-down", width="10", height="5.5")
          .menu__left-filters-item-bottom(:style="(filter.open) ? 'display: block' : ''")
            template(v-if="filter.range")
              vue-slider.menu__left-filters-item-range(v-if="filter.range", ref="slider" v-model="filterPrice" :min="filter.range[0]" :max="filter.range[1]" :tooltip="null" height="1px" @click.native="")
              .menu__left-filters-item-row
                .menu__left-filters-item-input-wr
                  .menu__left-filters-item-input-label от
                  input.menu__left-filters-item-input(v-model="filterPrice[0]")
                .menu__left-filters-item-input-wr
                  .menu__left-filters-item-input-label до
                  input.menu__left-filters-item-input(v-model="filterPrice[1]")
            template(v-else)
              .menu__left-filters-item-row(v-for="item in filter.items.slice(0, 5)", :key="item.id")
                label.chk
                  input.chk__el(type="checkbox" :name="item.name" :value="item.value" v-model="item.checked")
                  .chk__checkmark
                  | {{item.title}}
                .menu__left-filters-item-count(v-if="item.count", v-html="item.count")
              .menu__left-filters-item-bottom-more(v-if="filter.items.length > 5")
                .menu__left-filters-item-row(v-for="item in filter.items.slice(5, filter.items.length)", :key="item.id")
                  label.chk
                    input.chk__el(type="checkbox" :name="item.name" :value="item.value" v-model="item.checked")
                    .chk__checkmark
                    | {{item.title}}
                  .menu__left-filters-item-count(v-if="item.count", v-html="item.count")
              .menu__left-filters-item-bottom-more-btn-wr(v-if="filter.items.length > 5")
                .menu__left-filters-item-bottom-more-btn(@click="toggleMore($event, filter.btn.show, filter.btn.hide)") {{filter.btn.show}}
        .menu__left-filters-buttons
          button.menu__left-filters-button-apply(type="submit") Подобрать
          button.menu__left-filters-button-reset(type="button", @click="resetFilters") Сбросить
    .menu__right
      .menu__right-decor-bottom
      .menu__right-nav(v-if="menu.rightNav")
        router-link.menu__right-nav-item(v-for="item in menu.rightNav", :to="item.link", :key="item.id")
          | {{item.title}}
      .menu__right-items-wr
        .menu__right-preloader
          .menu__border.menu__border--right
          .menu__right-preloader-img
            .menu__right-preloader-img-color-wr
              .menu__right-preloader-img-color
        .menu__right-items(v-if="menuItems && menuItems.items && !menuItems.filters")
          .menu__right-item(v-for="item in menuItems.items", :key="item.id")
            a.menu__right-item-img-wr-link(:href="item.imageOriginSrc.path", v-if="item.imageOriginSrc")
              .menu__right-item-img-wr(:data-src="item.imagePreview.path")
                img.menu__right-item-img.menu__right-item-img--hide(:src="item.imagePreview.path")
            .menu__right-item-img-wr(v-else, :data-src="item.imagePreview.path")
              SvgIcon(name="bottle" width="32" height="95" class="menu__right-item-img-preloader")
              img.menu__right-item-img.menu__right-item-img--hide(:src="item.imagePreview.path")
            .menu__right-item-desc
              .menu__right-item-desc-title
                router-link.menu__right-item-desc-title-text.menu__right-item-desc-title-text--link(v-if="item.lnk", :to="item.lnk") {{item.name}}
                .menu__right-item-desc-title-text(v-else) {{item.name}}
                .menu__right-item-desc-title-border
                .menu__right-item-price {{item.price}} р.
              .menu__right-item-desc-row
                .menu__right-item-desc-left
                  .menu__right-item-desc-volume {{item.volume}}
                  .menu__right-item-desc-text {{item.description}}
                .menu__right-item-desc-right
                  .menu__right-item-text-breakfast(v-if="hideBreakfast && textBreakfast && item.delivered") {{textBreakfast}}
                  .menu__right-item-add-basket(:class="{'menu__right-item-add-basket--hide-breakfast': hideBreakfast}")
                    button.menu__right-item-button(:class="{'menu__right-item-button--hide': item.availableInCart}", v-if="item.delivered", @click="addProductToCartMenu($event, item.id, 'plus')") В корзину
                    .menu__right-item-no-delivered(v-if="!item.delivered") Не доставляется
                    .menu__right-item-counter(:class="{'menu__right-item-counter--hide': !item.availableInCart}", v-if="item.delivered && !hideBreakfast")
                      button.menu__right-item-counter-button.menu__right-item-counter-button--dec(type="button", @click="addProductToCartMenu($event, item.id, 'minus')", :class="{'menu__right-item-counter-button--disabled': item.count < 2}")
                      input.menu__right-item-counter-input(type="number", min="1", :value="item.count || 0", @input="addProductToCartMenu($event, item.id, 'input')")
                      button.menu__right-item-counter-button.menu__right-item-counter-button--inc(type="button", @click="addProductToCartMenu($event, item.id, 'plus')")
          button.menu__right-items-more(v-if="more", @click="loadMoreItems")
            SvgIcon(name="recycle" width="25" height="25" class="menu__right-items-more-loader")
            SvgIcon(name="arrow-down" width="12" height="7" class="menu__right-items-more-ico")
            .menu__right-items-more-text Еще...
        .menu__right-items-almanac(v-else-if="menuItems && menuItems.items && menuItems.items.length > 0 && menuItems.filters")
          .menu__right-items-almanac-notforsale
            .menu__corner.menu__corner--tl
            .menu__corner.menu__corner--tr
            .menu__corner.menu__corner--bl
            .menu__corner.menu__corner--br
            .menu__right-items-almanac-notforsale-title Не для продажи
          .menu__right-items-almanac-item(v-for="item in menuItems.items", :key="item.id")
            .menu__right-items-almanac-item-left
              img.menu__right-items-almanac-item-image(v-if="item.image", :src="item.image")
            .menu__right-items-almanac-item-center
              .menu__right-items-almanac-item-title(v-if="item.title", v-html="item.title")
              .menu__right-items-almanac-item-sku(v-if="item.sku", v-html="item.sku")
              .menu__right-items-almanac-item-chars
                .menu__right-items-almanac-item-chars-item(v-if="item.type && item.sugar")
                  .menu__right-items-almanac-item-chars-item-name(v-html="`${item.type}, ${item.sugar}`")
                .menu__right-items-almanac-item-chars-item(v-if="item.region")
                  .menu__right-items-almanac-item-chars-item-name Регион:
                  .menu__right-items-almanac-item-chars-item-value(v-html="item.region")
                .menu__right-items-almanac-item-chars-item(v-if="item.fortress")
                  .menu__right-items-almanac-item-chars-item-name Крепость:
                  .menu__right-items-almanac-item-chars-item-value(v-html="item.fortress")
                .menu__right-items-almanac-item-chars-item(v-if="item.manufacturer")
                  .menu__right-items-almanac-item-chars-item-name Производитель:
                  .menu__right-items-almanac-item-chars-item-value(v-html="item.manufacturer")
                .menu__right-items-almanac-item-chars-item(v-if="item.size")
                  .menu__right-items-almanac-item-chars-item-name Объем:
                  .menu__right-items-almanac-item-chars-item-value(v-html="item.size")
              .menu__right-items-almanac-item-description(v-if="item.description")
                .menu__right-items-almanac-item-description-name Описание:
                .menu__right-items-almanac-item-description-value(v-html="item.description")
            .menu__right-items-almanac-item-right
              .menu__right-items-almanac-item-price-wr(v-if="item.price")
                .menu__right-items-almanac-item-price(v-html="item.price")
                SvgIcon.menu__right-items-almanac-item-price-ico(name="rub", width="20", height="25")
          button.menu__right-items-more(v-if="more", @click="submitFilters(true)")
            SvgIcon(name="recycle" width="25" height="25" class="menu__right-items-more-loader")
            SvgIcon(name="arrow-down" width="12" height="7" class="menu__right-items-more-ico")
            .menu__right-items-more-text Еще...
        .menu__right-items-not-found(v-if="menuItems && menuItems.items && menuItems.items.length < 1 && menuItems.filters")
          .menu__right-items-not-found-title По Вашему запросу ничего не найдено
          .menu__right-items-not-found-text Попробуйте изменить параметры поиска
      .menu__right-wine
        .menu__right-preloader
          .menu__border.menu__border--right
          .menu__right-preloader-img
            .menu__right-preloader-img-color-wr
              .menu__right-preloader-img-color
        .menu__right-wine-bg(v-if="vinoItem && vinoItem.background", :style="`background-color: ${vinoItem.background}`")
          .menu__border.menu__border--right
          .menu__right-wine-decor-top
          .menu__right-wine-decor-bottom
          .menu__right-wine-content
            .menu__right-wine-left
              button.menu__right-wine-back(v-if="vinoItem && vinoItem.backText", @click="goBack")
                SvgIcon(name="back" width="7" height="12" class="menu__right-wine-back-ico")
                | {{vinoItem.backText}}
              .menu__right-wine-title(v-if="vinoItem && vinoItem.title") {{vinoItem.title}}
              .menu__right-wine-chars(v-if="vinoItem && vinoItem.chars")
                .menu__right-wine-chars-item(v-for="item in vinoItem.chars", :key="item.id") {{item.text}}
              .menu__right-wine-items(v-if="vinoItem && vinoItem.items")
                .menu__right-wine-item(v-for="item in vinoItem.items", :key="item.id")
                  .menu__right-wine-item-title
                    img.menu__right-wine-item-ico(v-if="vinoItem && item.img", :src="item.img")
                    |{{item.title}}
                  .menu__right-wine-item-text {{item.text}}
            .menu__right-wine-right
              .menu__right-wine-img-wr(v-if="vinoItem && vinoItem.img", :data-src="vinoItem.img")
                img.menu__right-wine-img.menu__right-wine-img--hide(:src="vinoItem.img")
              .menu__right-wine-price(v-if="vinoItem && vinoItem.price && vinoItem.currency") {{vinoItem.price}} {{vinoItem.currency}}
              .menu__right-wine-note(v-if="vinoItem && vinoItem.note", v-html="vinoItem.note")
</template>

<script>
import EventBus from '@/eventBus';

import 'vue-slider-component/theme/default.css';
//import '@/components/menu/menu.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import {CartHelpersVue} from '@/mixins/CartHelpersVue';
import {CommonHelpersVue} from '@/mixins/CommonHelpersVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import VueSlider from 'vue-slider-component';

export default {
  name: 'Menu',

  mixins: [AjaxHelpersVue, ImagePreloaderVue, CartHelpersVue, CommonHelpersVue],

  data() {
    return {
      menu: null,
      menuItems: null,
      vinoItem: null,
      isBack: false,
      backLink: '',
      ps: null,
      ps2: null,
      ps3: null,
      ps4: null,
      count: 0,
      perPage: 0,
      more: false,
      textBreakfast: null,
      hideBreakfast: false,
      filterPrice: false
    }
  },

  components: {
    SvgIcon,
    VueSlider
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadMenuPage', params => {
      this.request(params.url);
    });

    EventBus.$on('loadMenuPageInside', params => {
      this.requestInside(params);
    });

    EventBus.$on('resetMenuPage', params => {
      this.menu = null;
    });

    this.$nextTick(() => {
      this.setActiveClassRightMenu();
      this.setActiveClassLeftMenu();

      this.btnMobileInit();
    })
  },

  methods: {
    closeMenuLocal() {
      this.closeMenuPageMenu();
    },

    btnMobileInit() {
      let that = this;

      $(document).on('click', '.menu__left-btn-open', function() {
        $(this).toggleClass('menu__left-btn-open--open');

        $('.menu__left').toggleClass('menu__left--open');

        that.closeMenuMain();
      });
    },

    request(url) {
      let params = this.$route.params;

      this.req('MenuPage:getMenuPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.menu = res.content;
        }

        this.requestInside({params: params, url: this.$route.path});

        this.$nextTick(() => {
          this.setActiveClassRightMenuInitial();
        });
      }, 'menu');
    },

    initScripts() {
      if(this.ps) {
        this.ps.destroy();
        this.ps = null;
      }

      if(this.ps4 === null) {
        this.ps4 = new PerfectScrollbar('.menu__left-filters', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 100,
          maxScrollbarLength: 100
        });
      } else {
        this.ps4.update();
      }
    },

    toggleMore(e, showText, hideText) {
      $(e.target).parents('.menu__left-filters-item').find('.menu__left-filters-item-bottom-more').stop().slideToggle(250);

      if($(e.target).text() == showText) {
        $(e.target).text(hideText);
      } else {
        $(e.target).text(showText);
      }
    },

    submitFilters(more, reset = false) {
      let form = $('.menu__left-filters').serializeArray();
      let tipId = this.$route.params.tipId;
      let kategoriyaId = this.$route.params.kategoriyaId;

      if(!tipId) {
        let t = this.menu.rightNav[0].link.split('/');
        tipId = t[2];
      }

      if(!kategoriyaId) {
        let k = this.menuItems.leftNav[0].link.split('/');
        kategoriyaId = k[3];
      }

      let params = {
        tipId: tipId,
        kategoriyaId: kategoriyaId,
        price: this.filterPrice
      };

      $.each(form, function() {
        if(params[this.name] !== undefined) {
          if(!params[this.name].push) {
            params[this.name] = [params[this.name]];
          }
          params[this.name].push(this.value || '');
        }
        else {
          params[this.name] = this.value || '';
        }
      });

      if(more) {
        $('.menu__right-items-more').addClass('menu__right-items-more--loading');

        this.count = this.count + this.perPage;
        params.count = this.count;
      } else {
        this.count = 0;
        this.preloader('show');
      }

      if(reset) {
        delete params.price;
      }

      this.req('MenuPage:getMenuPageItems', {...params}, res => {
        if(this.checkProperty(res.content)) {
          if(more) {
            this.menuItems.items = this.menuItems.items.concat(res.content.items);
          } else {
            this.menuItems = res.content;
            this.perPage = this.menuItems.items.length;
          }

          this.more = res.content.more;

          this.menuItems.filters.items.forEach((el) => {
            if(el.range) {
              this.filterPrice = el.range;
            }
          });

          this.$nextTick(() => {
            if(more) {
              this.ps.update();

              setTimeout(() => {
                $('.menu__right-items-more').removeClass('menu__right-items-more--loading');
              }, 500);

            } else {
              this.preloader('hide');

              setTimeout(() => {
                this.initScroll();
              }, 100);
            }
          });
        }
      }, '', 'localPageRequest');
    },

    resetFilters() {
      $('.menu__left-filters')[0].reset();

      this.menuItems.filters.items.forEach((el) => {
        if(el.range) {
          this.filterPrice = el.range;
        }
      });

      setTimeout(() => {
        this.submitFilters(false, true);
      }, 100);
    },

    filterToggle(e) {
      let that = $(e.target).parents('.menu__left-filters-item');

      $(that).toggleClass('menu__left-filters-item--open');

      $(that).find('.menu__left-filters-item-bottom').stop().slideToggle(250);
    },

    requestInside(params) {
      this.count = 0;
      let tipId = params.params.tipId || '';
      let kategoriyaId = params.params.kategoriyaId || '';
      let vinoId = params.params.vinoId || '';
      let url = params.url || '';

      if(url == '/menyu' && tipId == 'almanakh-vin') {
        tipId = '';
      }


      if(!this.menu) {
        this.request('/menyu');
      }
      else {

        if(vinoId.length && url !== '/menyu') {
          this.requestVinoItem(vinoId, url);
        }
        else {
          if(!this.isBack) {
            this.backLink = url;

            this.$nextTick(() => {
              $('.menu__right-wine').removeClass('menu__right-wine--show');
              this.setActiveClassRightMenuInitial();
              this.setActiveClassLeftMenuInitial();
              this.preloader('show');
            });

            this.req('MenuPage:getMenuPageItems', {tipId, kategoriyaId}, res => {
              if(this.checkProperty(res.content)) {
                if(tipId == 'almanakh-vin') {
                  this.menuItems = res.content;
                  this.perPage   = this.menuItems.items.length;
                  this.more      = res.content.more;

                  if(this.menuItems && this.menuItems.filters && this.menuItems.filters.items) {
                    this.menuItems.filters.items.forEach((el) => {
                      if(el.range) {
                        this.filterPrice = el.range;
                      }
                    });
                  }

                  this.$nextTick(() => {
                    this.preloader('hide');
                    this.setActiveClassLeftMenuInitial();
                    this.initScripts();

                    setTimeout(() => {
                      this.initScroll();
                    }, 100);
                  });
                } else {
                  this.menuItems = res.content;
                  this.perPage = this.menuItems.items.length;
                  this.more = res.content.more;
                  this.textBreakfast = res.content.textBreakfast;
                  this.hideBreakfast = res.content.hideBreakfast;

                  this.$nextTick(() => {
                    this.imgPreloader('menu__right-item-img-wr', 'menu__right-item-img', 'menu__right-item-img-preloader', 250);
                    this.initFancy();
                    this.preloader('hide');
                    this.setActiveClassLeftMenuInitial();

                    setTimeout(() => {
                      this.initScroll();
                    }, 100);

                    if($(window).width() < 1600) {
                      this.initScroll3();
                    }
                  });
                }
              }
            }, '', 'localPageRequest');
          }
          else {
            this.isBack = false;
          }
        }

      }
    },

    requestVinoItem(vinoId, url) {
      if(!this.menuItems) {
        this.requestInside({params: {
            tipId: this.$route.params.tipId,
            kategoriyaId: this.$route.params.kategoriyaId
          }});
      }

      this.$nextTick(() => {
        $('.menu__right-wine').addClass('menu__right-wine--show');
        this.setActiveClassRightMenuInitial();
        this.setActiveClassLeftMenuInitial();
        this.preloader('show');
      });

      this.req('MenuPage:getMenuPageVinoItem', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.vinoItem = res.content;

          this.$nextTick(() => {
            this.imgPreloader('menu__right-wine-img-wr', 'menu__right-wine-img', '', 250);
            this.initScroll2();
            this.preloader('hide');
          });
        }
      }, '', 'localPageRequest');
    },

    preloader(action) {
      let $preloader = $('.menu__right-preloader');

      if(action === 'show') {
        $preloader.removeClass('menu__right-preloader--hide').addClass('menu__right-preloader--animation');
      }

      if(action === 'hide') {
        $preloader.addClass('menu__right-preloader--hide');

        setTimeout(() => {
          $preloader.removeClass('menu__right-preloader--animation');
        }, 500);
      }
    },

    setActiveClassRightMenuInitial() {
      let tipId = this.$route.params.tipId || '';

      $('.menu__right-nav-item').removeClass('menu__right-nav-item--active');

      if(tipId.length) {
        $(`.menu__right-nav-item[href*='${tipId}']`).addClass('menu__right-nav-item--active');
      }
      else {
        $('.menu__right-nav-item').eq(0).addClass('menu__right-nav-item--active');
      }
    },

    setActiveClassRightMenu() {
      let $items = $('.menu__right-nav-item');

      $(document).on('click', '.menu__right-nav-item', function() {
        $items.removeClass('menu__right-nav-item--active');

        $(this).addClass('menu__right-nav-item--active');

        $('.menu-left__nav-item').removeClass('menu-left__nav-item--active');

        if($(this).attr('href') == '/menyu/almanakh-vin') {
          $('.menu-left__nav-item[href="/menyu/almanakh-vin"]').addClass('menu-left__nav-item--active');
        } else {
          $('.menu-left__nav-item[href="/menyu"]').addClass('menu-left__nav-item--active');
        }
      });
    },

    setActiveClassLeftMenuInitial() {
      let kategoriyaId = this.$route.params.kategoriyaId || '';

      $('.menu__left-nav-item').removeClass('menu__left-nav-item--active');

      if(kategoriyaId.length) {
        $(`.menu__left-nav-item[href$='/${kategoriyaId}/']`).addClass('menu__left-nav-item--active');
      }
      else {
        $('.menu__left-nav-item').eq(0).addClass('menu__left-nav-item--active');
      }
    },

    setActiveClassLeftMenu() {
      let $items = $('.menu__left-nav-item');

      $(document).on('click', '.menu__left-nav-item', function() {
        $items.removeClass('menu__left-nav-item--active');

        $(this).addClass('menu__left-nav-item--active');
      });
    },

    goBack() {
      this.isBack = true;

      if(this.backLink) {
        this.$router.push({path: this.backLink});
      } else {
        var path = '/menyu/' + this.$route.params.tipId + '/' + this.$route.params.kategoriyaId;

        this.$router.push({path: path});
      }

      this.$nextTick(() => {
        $('.menu__right-wine').removeClass('menu__right-wine--show');
        this.setActiveClassRightMenuInitial();
        this.setActiveClassLeftMenuInitial();
      });
    },

    addProductToCartMenu(e, productId, type) {
      let $input = $(e.target).parents('.menu__right-item').find('input');
      let count = parseInt($input.val());
      let $minusBtn = $(e.target).parents('.menu__right-item').find('.menu__right-item-counter-button--dec');
      let minusBtnClass = 'menu__right-item-counter-button--disabled';
      let $cartWidget = $('.cart-widget');
      let cartWidgetClass = 'cart-widget--active';
      let $cartWidgetCount = $('.cart-widget__count');
      let cartWidgetCountClass = 'cart-widget__count--hide';
      let $cartWidgetCountNum = $('.cart-widget__count-num');

      count = this.getAmount($input, type, 1);
      $input.val(count);

      this.menuItems.items.forEach((el) => {
        if(el.id == productId) {
          el["availableInCart"] = true;
          el["count"] = count;
        }
      });

      if(count == '' || count == 0) {
        return false;
      }

      if(count < 2) {
        $minusBtn.addClass(minusBtnClass);
      } else {
        $minusBtn.removeClass(minusBtnClass);
      }

      let params = {
        cartId: this.getCartId(),
        productId: productId,
        amount: count
      };

      this.addToCart((res) => {
        if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
          this.$nextTick(() => {
            $cartWidgetCountNum.text(res.countProductsToCart);

            if(res.countProductsToCart > 0) {
              $cartWidget.addClass(cartWidgetClass);
              $cartWidgetCount.removeClass(cartWidgetCountClass);
            } else {
              $cartWidget.removeClass(cartWidgetClass);
              $cartWidgetCount.addClass(cartWidgetCountClass);
            }
          });
        }
      }, params);
    },

    initFancy() {
      $('.menu__right-item-img-wr-link').fancybox({
        image: {
          preload: true,
        },
        clickContent: function(current, event) {
          return current.type === "image" ? "zoom" : false;
        },
        dblclickContent: false,
        dblclickSlide: false,
        dblclickOutside: false,
        buttons: ['close'],
        infobar: false,
        hash: false
      });
    },

    initScroll() {
      let el = '';

      if($('.menu__right-items').length) {
        el = '.menu__right-items';
      } else if($('.menu__right-items-almanac').length) {
        el = '.menu__right-items-almanac';
      } else {
        return false;
      }

      if(this.ps === null) {
        this.ps = new PerfectScrollbar(el, {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      } else {
        const container = document.querySelector(el);
        container.scrollTop = 0;
        this.ps.update();
      }
    },

    initScroll2() {
      if(this.ps2 === null) {
        this.ps2 = new PerfectScrollbar('.menu__right-wine-content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      } else {
        this.ps2.update();
      }
    },

    initScroll3() {
      if(this.ps3 === null) {
        this.ps3 = new PerfectScrollbar('.menu__left-nav', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 100,
          maxScrollbarLength: 100
        });
      } else {
        this.ps3.update();
      }
    },

    loadMoreItems() {
      this.count = this.count + this.perPage;
      let count = this.count;
      let tipId = this.$route.params.tipId;
      let kategoriyaId = this.$route.params.kategoriyaId;

      if(!tipId) {
        let t = this.menu.rightNav[0].link.split('/');
        tipId = t[2];
      }

      if(!kategoriyaId) {
        let k = this.menuItems.leftNav[0].link.split('/');
        kategoriyaId = k[3];
      }

      $('.menu__right-items-more').addClass('menu__right-items-more--loading');

      this.req('MenuPage:getMenuPageItems', {tipId, kategoriyaId, count}, res => {
        if(this.checkProperty(res.content)) {
          this.menuItems.items = this.menuItems.items.concat(res.content.items);
          this.more = res.content.more;
        }

        this.$nextTick(() => {
          this.imgPreloader('menu__right-item-img-wr', 'menu__right-item-img', 'menu__right-item-img-preloader', 250);
          this.ps.update();
          this.initFancy();

          setTimeout(() => {
            $('.menu__right-items-more').removeClass('menu__right-items-more--loading');
          }, 500);
        });
      }, '', 'localPageRequest');
    }

    /*popupLocal(type, action) {
      this.popup(type, action);
    }*/
  }

}
</script>
